import { useLocation, useNavigate } from 'react-router-dom';

import * as S from './styles';
import { useMemo } from 'react';
import { usePermission } from 'hooks/usePermission';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from 'components/ui/dropdown-menu';

interface RouteChild {
  title: string;
  path: string;
  show?: boolean;
}

interface RouteBase {
  title: string;
  path: string;
  show?: boolean;
  children?: RouteChild[];
}

export const NavigationDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermissionTo } = usePermission();

  const routes: RouteBase[] = useMemo(
    () => [
      {
        title: 'Projeto UNO',
        path: '#projetouno',
        show: hasPermissionTo(['DASHBOARD.UNO']),
      },
      {
        title: 'Tracking',
        path: '#tracking',
        show: true,
        children: [
          {
            title: 'Entregas/Coletas Inbound Corteva',
            path: '#tracking-inbound-corteva',
            show: true,
          },
        ],
      },
      {
        title: 'GRs.',
        path: '#rework',
        show: hasPermissionTo(['DASHBOARD.REWORK']),
      },
      {
        title: 'Inventário',
        path: '#inventory',
        show: hasPermissionTo(['DASHBOARD.INVENTORY']),
      },
      {
        title: 'RCCP',
        path: '#rccp',
        show: hasPermissionTo(['DASHBOARD.RCCP']),
      },
      {
        title: 'Interditados',
        path: '#interdict',
        show: hasPermissionTo(['DASHBOARD.INTERDICT']),
      },
      {
        title: 'Métricas',
        path: '#metrics',
        show: hasPermissionTo(['DASHBOARD.METRICS']),
      },
      {
        title: 'Ocup. Utrisha',
        path: '#ocup-utrisha',
        show: true,
      },
      {
        title: 'Temperatura',
        path: '#temperature-control',
        show: hasPermissionTo(['DASHBOARD.TEMPERATURE_CONTROL']),
      },
      {
        title: 'Multas',
        path: '#multas',
        show: hasPermissionTo(['DASHBOARD.MULTAS']),
      },
    ],
    [hasPermissionTo]
  );

  const routesWithActived = useMemo(() => {
    return routes
      .filter(({ show }) => show)
      .map((route) => {
        const path = `/dashboard${route.path}`;
        const isEmptyHash =
          location.hash === '' && path === `/dashboard${routes[0].path}`;
        const isSamePath = path === `/dashboard${location.hash}`;

        const isChildActive = route.children?.some(
          (child) => `/dashboard${child.path}` === `/dashboard${location.hash}`
        );

        return {
          ...route,
          isActived: isSamePath || isEmptyHash || !!isChildActive,
        };
      });
  }, [location.hash, routes]);

  return (
    <S.Container>
      {routesWithActived.map((route) =>
        route.children && route.children.length > 0 ? (
          <DropdownMenu key={route.path}>
            <DropdownMenuTrigger asChild>
              <S.DropdownButton className={route.isActived ? 'actived' : ''}>
                {route.title}
              </S.DropdownButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" sideOffset={18}>
              {route.children
                .filter((child) => child.show)
                .map((child) => (
                  <DropdownMenuItem
                    key={child.path}
                    className="cursor-pointer"
                    onClick={() => navigate(`/dashboard${child.path}`)}
                  >
                    {child.title}
                  </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <S.Button
            key={route.path}
            to={`/dashboard${route.path}`}
            className={route.isActived ? 'actived' : ''}
          >
            {route.title}
          </S.Button>
        )
      )}
    </S.Container>
  );
};
